<app-accordion collapsible="true">
  <app-accordion-item
    [disabled]="!activeProperty()"
    [heading]="accordionHeader"
  >
    <div class="mb-6">
      <h4 class="text-sm font-semibold text-gray-700 mb-2">Layer Opacity</h4>
      <div class="flex items-center gap-3 mb-2">
        <label class="text-sm text-gray-600 min-w-0">Opacity:</label>
        <span class="text-sm font-medium text-gray-800">{{
          opacityLabel()
        }}</span>
      </div>
      <esk-slider
        [min]="0"
        [max]="100"
        [ngModel]="opacity()"
        (ngModelChange)="setLayerGroupOpacity($event)"
        [disabled]="!activeProperty()"
        class="w-full"
      ></esk-slider>
    </div>

    <div class="mb-6">
      <h4 class="text-sm font-semibold text-gray-700 mb-3">Crop Selection</h4>
      <div class="space-y-2">
        <label class="block text-sm text-gray-600"
          >Select a crop to display:</label
        >
        <esk-select
          [options]="layerMetaData()"
          class="w-full"
          [ngModel]="selectedCrop()"
          (ngModelChange)="selectedCrop.set($event)"
        >
          <ng-template #selectedOption let-option let-index="index">
            <div class="flex items-center gap-3 px-1">
              <img
                width="24"
                height="24"
                src="/assets/images/report-icons/{{ option.id }}.svg"
                alt="{{ option.displayName }} icon"
                class="flex-shrink-0"
              />
              <span class="text-sm">{{ option.displayName }}</span>
            </div>
          </ng-template>

          <ng-template #option let-option let-index="index">
            <div class="flex items-center gap-3 px-1">
              <img
                width="24"
                height="24"
                src="/assets/images/report-icons/{{ option.id }}.svg"
                alt="{{ option.displayName }} icon"
                class="flex-shrink-0"
              />
              <span class="text-sm">{{ option.displayName }}</span>
            </div>
          </ng-template>
        </esk-select>
      </div>
    </div>

    @if(paddockSelect()) {
    <div class="mb-6">
      <h4 class="text-sm font-semibold text-gray-700 mb-3">
        Paddock Selection
      </h4>
      <div class="space-y-2">
        <label class="block text-sm text-gray-600"
          >Select a paddock to display:</label
        >
        <esk-select
          [options]="paddockSelectModel()"
          class="w-full"
          [ngModel]="selectedPaddockIDs()"
          (ngModelChange)="selectedPaddockIDs.set($event)"
          [multi]="true"
        >
          <ng-template
            #selectedOption
            let-selectedOptions
            let-isMulti="isMulti"
          >
            <div class="flex items-center gap-1 px-1">
              @for (option of selectedOptions; track $index) {
              <span class="text-sm">{{ option.displayName }}</span>
              @if ($index < selectedOptions.length - 1) {
              <span class="text-sm text-gray-500">,</span>
              } }
            </div>
          </ng-template>
          <ng-template #option let-option let-index="index">
            <div class="flex items-center gap-3 px-1">
              <span class="text-sm">{{ option.displayName }}</span>
            </div>
          </ng-template>
        </esk-select>
      </div>
    </div>

    }

    <div class="space-y-3">
      <h4 class="text-sm font-semibold text-gray-700 mb-3">
        Suitability Legend
      </h4>
      <div class="grid gap-2">
        @for (color of colorIndex; track $index) {
        <div
          class="flex items-center gap-3 py-2 px-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
        >
          <div
            [ngStyle]="{ backgroundColor: color.color }"
            class="w-4 h-4 rounded border border-gray-200 flex-shrink-0"
            [title]="color.name | spaceBeforeCap"
          ></div>
          <span class="text-sm text-gray-700 font-medium">
            {{ color.name | spaceBeforeCap }}
          </span>
        </div>
        }
      </div>
    </div>
  </app-accordion-item>
</app-accordion>

<ng-template #accordionHeader>
  <div class="flex content-center items-center gap-1">
    <esk-switch
      [disabled]="!activeProperty()"
      (click)="$event.stopPropagation()"
      [ngModel]="visible()"
      (ngModelChange)="setLayerGroupVisibility($event)"
    ></esk-switch>

    @if(!isDownloaded() && activeProperty()) {
    <button
      [disabled]="!activeProperty()"
      (click)="downloadLayers.emit(true)"
      class="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
    >
      Download Layer Data
    </button>
    }
  </div>

  {{ title() }}
</ng-template>
